export const NO_CAPTURE_CLASS = 'tracking-no-capture';
export const NO_CAPTURE_SELECTOR = `.${NO_CAPTURE_CLASS}`;
